const DemandCollectionActionTypes = {
	/** ***************** GET DEMAND COLLECTION LIST START *********************** */
	GET_DEMAND_COLLECTION_LIST_START: 'get_demand_collection_start',
	GET_DEMAND_COLLECTION_LIST_SUCCESS: 'get_demand_collection_success',
	GET_DEMAND_COLLECTION_LIST_FAILURE: 'get_demand_collection_failure',
	GET_DEMAND_COLLECTION_LIST_RESPONSE_RESET: 'get_demand_collection_response_reset',
	GET_DEMAND_COLLECTION_LIST_RESPONSE_CHANGED: 'get_demand_collection_response_changed',
	/** ***************** GET DEMAND COLLECTION LIST END *********************** */
};
export default DemandCollectionActionTypes;
